var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDollarCoin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8C16.5 12.4181 12.9181 16 8.5 16C4.08195 16 0.5 12.4181 0.5 8C0.5 3.58195 4.08195 0 8.5 0C12.9181 0 16.5 3.58195 16.5 8Z",
    fill: "url(#paint0_linear_8715_6926)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66389 7.24925C1.77316 6.47965 1.91567 5.76231 2.22921 5.01172C2.42874 4.53666 2.65677 4.0331 2.97031 3.62455C3.13658 3.41077 3.35035 3.235 3.54988 3.04498C3.46912 2.98322 3.39311 2.92146 3.30285 2.8692C3.09857 2.74569 2.87529 2.64593 2.65202 2.55566C1.50712 3.78132 0.742277 5.36326 0.552254 7.12098C0.932301 7.20649 1.3076 7.28726 1.66389 7.24925Z",
    fill: "#FFFDC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.557007 8.26603C0.557007 3.84798 3.86817 0.180523 8.55701 0.137767C12.3575 0.0997625 15.5309 2.91686 16.348 6.47031C15.6354 2.78385 12.3955 0 8.5 0C4.08195 0 0.5 3.58195 0.5 8C0.5 8.61758 0.576009 9.21615 0.709026 9.79572C0.614014 9.30166 0.557007 8.7886 0.557007 8.26603Z",
    fill: "#FFFDC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1713 10.8412C16.7059 7.12598 14.9382 2.87014 11.223 1.3355C7.50781 -0.199133 3.25197 1.56857 1.71733 5.28377C0.182698 8.99897 1.9504 13.2548 5.6656 14.7894C9.38081 16.3241 13.6366 14.5564 15.1713 10.8412Z",
    fill: "#FFFF5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.2775C4.48575 15.2775 1.22209 12.0138 1.22209 7.99959C1.22209 3.98534 4.48575 0.72168 8.5 0.72168C12.5143 0.72168 15.7779 3.98534 15.7779 7.99959C15.7779 12.0138 12.5143 15.2822 8.5 15.2775Z",
    fill: "url(#paint1_linear_8715_6926)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7399 7.24885C15.6116 7.22509 15.4834 7.19659 15.3551 7.17284C15.0463 7.11583 14.3432 6.8593 14.0867 6.97806C14.0154 6.79279 13.9869 6.82129 14.0059 7.07308C13.9917 7.2916 13.9679 7.51013 13.9347 7.72866C13.7352 9.14909 13.3029 10.5458 12.5 11.7239C12.9846 12.0992 13.4834 12.4412 13.9584 12.8023C15.0891 11.5196 15.7779 9.84267 15.7779 7.99944C15.7827 7.74766 15.7684 7.49588 15.7399 7.24885Z",
    fill: "#FFD500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.8261C12.2702 14.8261 15.3266 11.7697 15.3266 7.99945C15.3266 4.22923 12.2702 1.17285 8.5 1.17285C4.72977 1.17285 1.67339 4.22923 1.67339 7.99945C1.67339 11.7697 4.72977 14.8261 8.5 14.8261Z",
    fill: "url(#paint2_linear_8715_6926)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8715_6926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77791 3.31132V2.57023L9.33611 2.53223L9.45962 2.7175V3.31132C10.9181 3.53935 11.6639 4.38971 11.6639 5.74363V6.05717H9.63064L9.56889 5.9289L9.71615 5.64387C9.71615 4.93128 9.34086 4.66524 8.68528 4.66524C8.02969 4.66524 7.6544 4.93603 7.65915 5.64387C7.65915 7.69137 11.6781 7.79113 11.6781 10.632C11.6781 11.9812 10.9133 12.8505 9.45487 13.0785V13.8054H7.80642L7.66865 13.4776V13.0643C6.19121 12.8363 5.54038 11.9859 5.54038 10.6367L5.49763 9.72463H7.39311L7.48338 9.84814V10.7365C7.48338 11.4491 7.89668 11.7009 8.54751 11.7009C9.20309 11.7009 9.61164 11.4443 9.61164 10.7365C9.61164 8.689 5.59264 8.58923 5.59264 5.74838C5.61164 4.40396 6.33848 3.54885 7.77791 3.31132Z",
    fill: "url(#paint3_linear_8715_6926)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68289 3.25432V2.53223H9.32185V3.25432C10.7423 3.47759 11.4691 4.30895 11.4691 5.62011V5.92415H9.57363V5.52035C9.57363 4.82676 9.20784 4.56548 8.57126 4.56548C7.93468 4.56548 7.56888 4.82676 7.56888 5.52035C7.56888 7.5156 11.4881 7.61061 11.4881 10.3802C11.4881 11.6961 10.7423 12.5417 9.32185 12.7603V13.4681H7.68289V12.7603C6.24347 12.537 5.51662 11.6961 5.51662 10.3802V9.71513H7.41211V10.4752C7.41211 11.1688 7.81116 11.4158 8.45249 11.4158C9.08907 11.4158 9.49287 11.1688 9.49287 10.4752C9.49287 8.47997 5.57363 8.38496 5.57363 5.61536C5.56888 4.31845 6.27672 3.4871 7.68289 3.25432Z",
    fill: "url(#paint4_linear_8715_6926)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7399 12.8268C7.7209 12.822 7.7019 12.8173 7.67815 12.8125V13.4728H7.7399V12.8268Z",
    fill: "#FFF188"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.633 8.48468C9.89668 7.78159 8.85155 7.33504 8.19122 6.74121C8.8278 7.34929 9.87768 7.79109 10.633 8.48468Z",
    fill: "#FFF188"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57364 5.92369H9.6354V5.58165C9.6354 5.22535 9.53563 4.98307 9.35511 4.83105C9.49763 4.98307 9.57839 5.20635 9.57839 5.51989L9.57364 5.92369Z",
    fill: "#FFF188"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54276 11.5483C9.17934 11.5483 9.61639 11.2491 9.61639 10.5555C9.61639 10.0519 9.2981 9.65285 8.92756 9.32031C9.26485 9.6386 9.48813 10.0044 9.48813 10.4795C9.48813 11.173 9.08908 11.4201 8.44775 11.4201C8.13421 11.4201 7.87767 11.3583 7.69715 11.2158C7.87767 11.4011 8.18646 11.5483 8.54276 11.5483Z",
    fill: "#FFF188"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57364 10.4417V9.7766H7.40737V9.71484H5.51188V10.3799C5.51188 11.064 5.7114 11.6151 6.1057 12.0236C5.75416 11.6246 5.57364 11.0925 5.57364 10.4417Z",
    fill: "#FFF188"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48575 7.57722C5.98694 7.10217 5.63064 6.51309 5.63064 5.67699C5.63064 4.37532 6.39074 3.59148 7.79216 3.35395V2.64136H9.32186V2.52734H7.6829V3.24943C6.28147 3.48696 5.56889 4.31357 5.56889 5.61523C5.56889 6.48934 5.95368 7.09266 6.48575 7.57722Z",
    fill: "#FFF188"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37886 3.31118C10.0629 3.41569 10.5808 3.66747 10.9371 4.04277C10.5903 3.64372 10.0629 3.38244 9.37886 3.26367V3.31118Z",
    fill: "#FFF188"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8715_6926",
    x: 5.09763,
    y: 2.13223,
    width: 8.18052,
    height: 13.2734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.777718 0 0 0 0 0.270544 0 0 0 0 0.00681366 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8715_6926"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8715_6926",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8715_6926",
    x1: 5.36069,
    y1: -0.0252438,
    x2: 11.622,
    y2: 15.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFE300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7218,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7919,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#FFAC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8715_6926",
    x1: 5.64475,
    y1: 0.700338,
    x2: 11.3398,
    y2: 15.2553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F8A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7205,
    stopColor: "#E74F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    stopColor: "#E95600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8597,
    stopColor: "#F06A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9587,
    stopColor: "#FA8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8715_6926",
    x1: 5.82184,
    y1: 1.1528,
    x2: 11.1638,
    y2: 14.8056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFE300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7218,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8715_6926",
    x1: 6.00595,
    y1: 3.18353,
    x2: 11.0406,
    y2: 12.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E44E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8715_6926",
    x1: 5.96313,
    y1: 3.12435,
    x2: 10.868,
    y2: 12.5821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#FDEEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFF049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFDA00"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollarCoin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DollarCoin.946d6db5.svg";
export { ForwardRef as ReactComponent };